import request from '@/utils/request'

// 获取ERP同步配置列表
export function getSyncConfigList() {
  return request({
    url: '/sync/list',
    method: 'get'
    // 使用默认超时时间
  })
}

// 执行单个表同步
export function syncSingleTable(tableName) {
  return request({
    url: '/sync/call',
    method: 'post',
    params: {
      tableName
    },
    timeout: 300000 // 5分钟超时时间，防止同步时间过长导致超时
  })
}

// 执行所有表同步
export function syncAllTables() {
  return request({
    url: '/sync/callAll',
    method: 'post',
    // 无需参数
    timeout: 600000 // 10分钟超时时间，防止同步时间过长导致超时
  })
}

// 自动生成工单
export function autoGenerateWorkOrders() {
  return request({
    url: '/sync/autoGenerateWorkOrders',
    method: 'post',
    timeout: 600000 // 10分钟超时时间
  })
}

// 获取同步记录列表
export function getSyncRecordList(params) {
  return request({
    url: '/system/sync/record/page',
    method: 'get',
    params
  })
}

// 获取同步记录详情
export function getSyncRecordDetail(id) {
  return request({
    url: `/system/sync/record/${id}`,
    method: 'get'
  })
}

// 获取任务名称列表
export function getTaskNameList() {
  return request({
    url: '/system/sync/record/taskNameList',
    method: 'get'
  })
}

// 推送工单数据
export function pushWorkOrders(data) {
  return request({
    url: '/sync/pushWorkOrders',
    method: 'post',
    data: data?data:{},
    timeout: 300000 // 5分钟超时时间
  })
}